let messages = {
    required: "Pole je povinné",
    requiredIf: "Pole je povinné",
    requiredUnless: "Pole je povinné",
    email:"Nesprávny formát emailu",
    sameAs:"Heslá sa nezhodujú",
    maxValue: "Prekročená maximálna hodnota",
    checked: "Pole je povinné"
};
export default {
    msg(msg_txt, additional) {
        for (var i in additional) {
            if (i === msg_txt) {
                return additional[i];
            }
        }
        for (var i in messages) {
            if (i === msg_txt) {
                return messages[i];
            }
        }
        return msg_txt;
    }
}





// WEBPACK FOOTER //
// ./src/public_app/api/messages.js